const Title = ({ title }) => {
  return <span className="title_component">{title}</span>
}

export default Title
